<template>
  <FormRadioGroupField :label="prompt" :options="{'Yes': true, 'No': false}" v-model="enabled" @change="onInput()"/>

  <div v-if="enabled">
    <HalfColumn>
        <FormTextField label="Who pays? *" v-model="expense.payerName" trimmed @change="onInput()"/>
    </HalfColumn>
    
    <Columns>
        <FormTextField label="How much ($)? *" v-model="expense.amount" numeric @change="onInput()"/>
        <FormSelectField label="Payment frequency *" :options="GeorgiaDfcsBenefits.PaymentFrequency" v-model="expense.frequency" @update:modelValue="onInput()"/>
    </Columns>
  </div>

</template>

<script lang="ts" setup>
import { GeorgiaDfcsBenefits } from "@minicity/core";
import { onMounted, ref } from "vue";

const props = defineProps<{
  modelValue?: Partial<GeorgiaDfcsBenefits.ShelterOrUtilityExpense>|null,
    prompt: string,
}>();

const enabled = ref<boolean|null>(null);
const expense = ref<Partial<GeorgiaDfcsBenefits.ShelterOrUtilityExpense>>({payerName: ""});

// Event for two-way binding
const emit = defineEmits(['update:modelValue']);

const onInput = () => {
  if (enabled.value === true) {
    if (!expense.value.amount || !expense.value.frequency || expense.value.payerName!.length == 0) {
      // Validation error
      emit('update:modelValue', undefined);
    } else {
      emit('update:modelValue', {...expense.value});
    }
  } else if (enabled.value === false) {
    emit('update:modelValue', null);
  } else {
    emit('update:modelValue', undefined);
  }
};

onMounted(() => {
  if (props.modelValue === undefined) {
    // Nothing
  } else if (props.modelValue === null) {
    // No expense
    enabled.value = false;
  } else {
    // Expense
    enabled.value = true;
    expense.value = {...props.modelValue};
  }
})
</script>

<style scoped>
</style>